import React from 'react';

import { ShimmerStyled, ShimmerWrapperStyled } from './Skeleton.styled';

const Shimmer = (): JSX.Element => (
  <ShimmerWrapperStyled>
    <ShimmerStyled />
  </ShimmerWrapperStyled>
);

export default Shimmer;
